import React, {createContext, useCallback, useContext, useMemo, useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {PageContainerContext} from '../components/PageContainer/PageContainerContext';

const STORAGE_KEY = 'wideLayout';

const WideLayoutContext = createContext(null);

const getStoredPreferences = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch {
  }
  return {};
};

const savePreferences = (preferences) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences));
  } catch {
  }
};

const getPageKey = (pathname) => {
  return pathname.replace(/\/\d+/g, '/:id').replace(/\/+$/, '').replace(/(\/:id)+$/, '') || '/';
};

export const WideLayoutProvider = ({children}) => {
  const [preferences, setPreferences] = useState(getStoredPreferences);
  const location = useLocation();
  const pageKey = getPageKey(location.pathname);

  const isWide = !!preferences[pageKey];

  useEffect(() => {
    savePreferences(preferences);
  }, [preferences]);

  const toggleWideLayout = useCallback(() => {
    setPreferences((previous) => {
      const updated = {...previous};
      if (updated[pageKey]) {
        delete updated[pageKey];
      } else {
        updated[pageKey] = true;
      }
      return updated;
    });
  }, [pageKey]);

  const value = useMemo(() => ({
    isWide,
    toggleWideLayout,
  }), [isWide, toggleWideLayout]);

  const pageContainerValue = useMemo(() => ({
    wide: isWide,
  }), [isWide]);

  return (
    <WideLayoutContext.Provider value={value}>
      <PageContainerContext.Provider value={pageContainerValue}>
        {children}
      </PageContainerContext.Provider>
    </WideLayoutContext.Provider>
  );
};

export const useWideLayout = () => {
  const context = useContext(WideLayoutContext);
  if (!context) {
    throw new Error('useWideLayout must be used within a WideLayoutProvider');
  }
  return context;
};
